import type { MouseEventHandler, ReactNode } from "react";
import { AlertTriangle } from "lucide-react";

import { cn } from "@/lib/utils";

/**
 * The amber default-history pill of the applications table; it opens the Default History tab.
 * `clear`: none were found, a quiet grey pill that still opens the tab (its empty state).
 */
export function DefaultHistoryPill({
  onClick,
  clear = false,
  className,
  children,
}: {
  onClick: MouseEventHandler<HTMLButtonElement>;
  clear?: boolean;
  className?: string;
  children: ReactNode;
}) {
  return (
    <button
      type="button"
      className={cn(
        "inline-flex items-center gap-1 rounded-full border px-2.5 py-0.5 text-[11px] font-semibold transition-colors",
        clear
          ? "border-transparent bg-secondary text-secondary-foreground sm:hover:bg-secondary/80"
          : "border-amber-200 bg-amber-50 text-amber-700 sm:hover:bg-amber-100",
        className
      )}
      onClick={onClick}
    >
      {!clear && <AlertTriangle className="h-3 w-3" />}
      {children}
    </button>
  );
}
